import { createGlobalStyle } from 'styled-components';
import graphik from '~/fonts/graphik.woff';
import graphik2 from '~/fonts/graphik.woff2';
import graphikB from '~/fonts/graphik-bold.woff';
import graphikB2 from '~/fonts/graphik-bold.woff2';
import graphikL from '~/fonts/graphik-light.woff';
import graphikL2 from '~/fonts/graphik-light.woff2';
import graphikSB from '~/fonts/graphik-semibold.woff';
import graphikSB2 from '~/fonts/graphik-semibold.woff2';
import graphikCompact from '~/fonts/graphik-compact.woff';
import graphikCompact2 from '~/fonts/graphik-compact.woff2';
import graphikCompactB from '~/fonts/graphik-compact-bold.woff';
import graphikCompactB2 from '~/fonts/graphik-compact-bold.woff2';
import graphikCompactL from '~/fonts/graphik-compact-light.woff';
import graphikCompactL2 from '~/fonts/graphik-compact-light.woff2';
import graphikCompactSB from '~/fonts/graphik-compact-semibold.woff';
import graphikCompactSB2 from '~/fonts/graphik-compact-semibold.woff2';

export const ApplicationGlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Graphik';
    font-display: swap;
    font-style: normal;
    font-weight: 400;
    src: url(${graphik}) format('woff'),
        url(${graphik2}) format('woff2');
  }
  @font-face {
    font-family: 'Graphik';
    font-display: swap;
    font-style: normal;
    font-weight: 800;
    src: url(${graphikB}) format('woff'),
        url(${graphikB2}) format('woff2');
  }
  @font-face {
    font-family: 'Graphik';
    font-display: swap;
    font-style: normal;
    font-weight: 100;
    src: url(${graphikL}) format('woff'),
        url(${graphikL2}) format('woff2');
  }
  @font-face {
    font-family: 'Graphik';
    font-display: swap;
    font-style: normal;
    font-weight: 600;
    src: url(${graphikSB}) format('woff'),
        url(${graphikSB2}) format('woff2');
  }
  @font-face {
    font-family: 'GraphikCompact';
    font-display: swap;
    font-style: normal;
    font-weight: 400;
    src: url(${graphikCompact}) format('woff'),
        url(${graphikCompact2}) format('woff2');
  }
  @font-face {
    font-family: 'GraphikCompact';
    font-display: swap;
    font-style: normal;
    font-weight: 800;
    src: url(${graphikCompactB}) format('woff'),
        url(${graphikCompactB2}) format('woff2');
  }
  @font-face {
    font-family: 'GraphikCompact';
    font-display: swap;
    font-style: normal;
    font-weight: 100;
    src: url(${graphikCompactL}) format('woff'),
        url(${graphikCompactL2}) format('woff2');
  }
  @font-face {
    font-family: 'GraphikCompact';
    font-display: swap;
    font-style: normal;
    font-weight: 600;
    src: url(${graphikCompactSB}) format('woff'),
        url(${graphikCompactSB2}) format('woff2');
  }
  body {
    height: 100vh;
  }
  #app {
    display: flex;
    height: 100vh;
    overflow: hidden;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      appearance: textfield;
    }
`;
